import apiSlice from "./ApiSlice";
import { InquiryFormValues } from "src/models/Inquiry.model";

export const inquiryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get
    getInquiry: builder.query({
      providesTags: ["inquiry", "followup"],
      query: (body) => {
        return {
          url: "/inquiry",
          method: "POST",
          body,
        };
      },
    }),

    // ADD
    addInquiry: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: (body: InquiryFormValues) => {
        return {
          url: "/inquiry/add",
          method: "POST",
          body,
        };
      },
    }),
    //Single View
    viewInquiry: builder.query({
      providesTags: ["inquiry"],
      query: (id: any) => {
        return {
          url: `/inquiry/${id}`,
          method: "GET",
        };
      },
    }),
    //Edit
    editInquiry: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: ({ body, id }: any) => {
        return {
          url: `/inquiry/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Move To Archive
    moveToArchive: builder.mutation({
      invalidatesTags: ["inquiry"],
      query: ({ body, id }) => {
        return {
          url: `/inquiry/move-to-archive/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
   

      //Get Query  FollowUp 
      getQueryActionsListing: builder.query({
        providesTags: ["inquiry", "followup"],
        query: (id) => {
          return {
            url: `/query/${id}/actions`,
            method: "GET",
          };
        },
      }),
  
      // Update Query FollowUp
      updateQueryAction: builder.mutation({
        invalidatesTags: ["inquiry"],
        query: ({id , body} :any ) => {
          return {
            url: `/query-action/${id}`,
            method: "PUT",
            body
          };
        },
      }),


  }),
});

export const {
  useGetInquiryQuery,
  useAddInquiryMutation,
  useViewInquiryQuery,
  useEditInquiryMutation,
  useMoveToArchiveMutation,
  useGetQueryActionsListingQuery ,
   useUpdateQueryActionMutation
} = inquiryApi;
